import React from 'react';
import { Row, Col } from 'antd';
import { Formik, Form as FormikForm } from 'formik';
import Logo from 'assets/logo/logo_full.png';
import InputField from 'shared/components/InputField';
import COButton from 'shared/components/COButton';
import styles from './AddUserForm.module.scss';
import {
  initialValues,
  Fields,
  validationSchema,
} from './AddUserFormConstants';
import { AddUserFormEnums } from 'enums/AddUserFormEnums';
import { useNavigate } from 'react-router-dom';

const AddUserForm = () => {
  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };
  return (
    <div className={styles.formContainer}>
      <Row className={styles.logoContainer}>
        <img
          src={Logo}
          alt={AddUserFormEnums.IMAGE_ALT}
          className={styles.logo}
        />
      </Row>
      <Row className={styles.headingContainer}>
        <div>
          <h1>{AddUserFormEnums.HEADING}</h1>
        </div>
        <div>
          <h2>{AddUserFormEnums.SUBHEADING}</h2>
        </div>
      </Row>
      <div className={styles.fieldsContainer}>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={values => {}}>
          {formik => (
            <FormikForm>
              {Fields.map((field, index) => {
                return (
                  <div key={index} className={styles.fieldContainer}>
                    <InputField
                      disabled={field.disabled}
                      name={field.name}
                      password={field.password}
                      placeholderstring={field.placeholder}
                      label={field.label}
                    />
                  </div>
                );
              })}

              <div className={styles.buttonContainer}>
                <COButton submit disabled={!formik.isValid}>
                  {AddUserFormEnums.BUTTON_LABEL_SUBMIT}
                </COButton>
                <COButton secondary onClick={handleGoBack}>
                  {AddUserFormEnums.BUTTON_LABEL_BACK}
                </COButton>
              </div>
            </FormikForm>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default AddUserForm;
